import React from "react";

const FeaturedBlogCard = ({
  image,
  date,
  title,
  link = "#",
}) => {
  return (
    <div className="w-full relative rounded-2xl overflow-hidden">
      {/* Background Image */}
      <img
        src="https://bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=300%20300w,%20//bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=400%20400w,%20//bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=500%20500w,%20//bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=600%20600w,%20//bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=700%20700w,%20//bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=800%20800w,%20//bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=900%20900w,%20//bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=1000%201000w"
        alt={title}
        className="w-full h-full object-cover"
      />

      {/* Overlay dark background */}
      <div className="absolute inset-0 bg-opacity-60"></div>

      {/* Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <p className="text-white text-sm md:text-base mb-2">{date}</p>
        <h2 className="text-white text-xl md:text-3xl font-bold mb-4 max-w-2xl">
          {title}
        </h2>
        <a
          href={link}
          className="bg-white text-black rounded-full px-6 py-2 font-medium transition hover:bg-gray-200"
        >
          Learn More
        </a>
      </div>
    </div>
  );
};

export default FeaturedBlogCard;
